import 'reflect-metadata'

import { createApp, h } from 'vue'
import { Icon, type IconProps } from '@iconify/vue'
import { createVuetify, type IconSet, type ThemeDefinition } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles'
import '@adereso-ai/vue-components/styles'
import './styles/adereso-theme.scss'
import App from './App.vue'
import router from './router'
// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app'
import Toast from 'vue-toastification'
// Import the CSS or use your own!
import 'vue-toastification/dist/index.css'

const vueApp = createApp(App)

const iconify = {
  component: (props: IconProps) => h(Icon, props)
} as IconSet

const lightTheme: ThemeDefinition = {
  dark: false,
  colors: {
    background: '#FAFAF7',
    surface: '#FFFFFF',
    primary: '#186EFA',
    secondary: '#7028F0',
    success: '#2DBC58',
    warning: '#FFD540',
    error: '#FF4E4E',
    info: '#608BFF'
  }
}

const darkTheme: ThemeDefinition = {
  dark: true,
  colors: {
    background: '#151513',
    surface: '#21211F',
    primary: '#608BFF',
    secondary: '#995CF6',
    success: '#76D692',
    warning: '#FFE26F',
    error: '#FF7C6F',
    info: '#8BA8FF'
  }
}

const storedTheme = window.localStorage.getItem('adereso-bsp-theme')
const initialTheme = storedTheme === 'light' || storedTheme === 'dark'
  ? storedTheme
  : window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'

document.documentElement.style.colorScheme = initialTheme

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'iconify',
    sets: { iconify }
  },
  theme: {
    defaultTheme: initialTheme,
    themes: {
      light: lightTheme,
      dark: darkTheme
    }
  }
})

vueApp.use(vuetify)
vueApp.use(router)
vueApp.use(Toast, {})
vueApp.mount('#app')

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: 'AIzaSyDQr0Ny3UW6D7ybQZgvksISY2insFxKQJ0',
  authDomain: 'adereso-bsp.firebaseapp.com',
  projectId: 'adereso-bsp',
  storageBucket: 'adereso-bsp.appspot.com',
  messagingSenderId: '184593836063',
  appId: '1:184593836063:web:097ecb1d75ba9c06c08d2a'
}

// Initialize Firebase
const app = initializeApp(firebaseConfig)

export { app }
